export default __webpack_public_path__ + "60c726e6c698e2b2ffe3a38df7e06e74.jpg";